import React from 'react';
import PropTypes from 'prop-types';

import LoadingSpinner from 'js/components/loading_spinner';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

const AddDistributionButton = ({
    distributionInProgress,
    createPotentialDistribution,
    currentVisiblePost,
    assignmentError
}) => {
    if (assignmentError) {
        const message =
            assignmentError.message ||
            'There was an issue assigning the distribution using your selection. This has been reported to the engineering team.';

        const tooltip = <Tooltip id="assignment-error-tooltip">{message}</Tooltip>;

        return (
            <OverlayTrigger placement="top" overlay={tooltip} show defaultOverlayShown>
                <button className="btn btn-danger" disabled>
                    <i className="fa fa-exclamation-circle" />
                </button>
            </OverlayTrigger>
        );
    }

    const ctaButtonContent = distributionInProgress ? <LoadingSpinner /> : 'Add Distribution';

    return (
        <button
            className="btn btn-success distribution-modal-button"
            disabled={distributionInProgress}
            onClick={() => createPotentialDistribution(currentVisiblePost)}
        >
            {ctaButtonContent}
        </button>
    );
};

AddDistributionButton.propTypes = {
    distributionInProgress: PropTypes.bool.isRequired,
    createPotentialDistribution: PropTypes.func.isRequired,
    currentVisiblePost: PropTypes.object
};

export default AddDistributionButton;



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/content_row/add_distribution_modal/add_distribution_button.js